import script from "./internationalAir.vue?vue&type=script&setup=true&lang=js"
export * from "./internationalAir.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__